import { formatCurrencyExact } from '@/lib/currency';

/**
 * Order money helpers shared by the orders page and modals. Totals are always
 * NET of refunds: Σ price × (quantity − refundedQuantity). `refundedQuantity`
 * is absent on orders created before partial refunds existed, so it always
 * coalesces to 0.
 */
export function remainingQuantity(product) {
	return Math.max(0, (Number(product?.quantity) || 1) - (Number(product?.refundedQuantity) || 0));
}

export function netOrderTotal(order) {
	return order?.products?.reduce((sum, p) => sum + (Number(p.price) || 0) * remainingQuantity(p), 0) ?? 0;
}

export function orderCurrency(order) {
	return order?.products?.[0]?.currency || 'GBP';
}

export function formatAmount(amount, currency) {
	return formatCurrencyExact(amount, currency);
}

export function formatOrderPrice(order) {
	return formatAmount(netOrderTotal(order), orderCurrency(order));
}

// The wire stores refundPending as the string 'true' (DynamoDB sparse-index
// friendly); accept the boolean too for optimistic local patches.
export function isRefundPending(order) {
	return order?.refundPending === 'true' || order?.refundPending === true;
}

const ITEM_REFUNDABLE_STATUSES = new Set(['paid', 'confirmed', 'partially_refunded']);

// Paid-online orders can have lines refunded before or after confirmation.
// Hidden while a refund is processing: the endpoint rejects a second one until it settles.
export function canRefundItems(order) {
	return order?.orderType === 'click-collect' && ITEM_REFUNDABLE_STATUSES.has(order?.status) && !isRefundPending(order);
}
